/* this file is transformed by vux-loader */
/* eslint-disable */
import _asyncToGenerator from "F:/zhaoyanning/\u627F\u5FB7\u5E02\u653F\u5E9C-\u5BF9\u63A5\u94F6\u884C/mobile-master/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "regenerator-runtime/runtime.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.splice.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.split.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import positon from '@/components/position';
import commonFaile from '@/components/commonFaile';
export default {
  name: 'OutSide',
  components: {
    positon: positon,
    commonFaile: commonFaile
  },
  data: function data() {
    return {
      value: '',
      timeArr: [{
        src: require('@/assets/face/daka.png'),
        title: '上班打卡'
      }, {
        src: require('@/assets/face/xiaban.png'),
        title: '下班打卡'
      }, {
        src: require('@/assets/face/qita.png'),
        title: '其他原因'
      }],
      imgArr: [],
      currentIndex: -1,
      wqCheck: false,
      //外勤是否开启人脸验证
      wqImage: false,
      //外勤是否开启照片上传
      show: false,
      userSerial: '',
      isShow: false,
      msg: '',
      time: '',
      img_src: require('@/assets/face/position_success.png'),
      isWq: false,
      isError: false,
      errorMsg: '当前照片与考勤人员不符，请重新核验',
      errorTitle: '外勤打卡失败',
      btn: '重新核验',
      currentTime: null,
      isFresh: false,
      arr: [],
      disabled: false,
      params: {
        customerName: '',
        //客户名称
        outsideInfo: '',
        //描述详情
        userSerial: this.$utils.Store.getItem('userSerial'),
        //人员序号
        sj: '',
        //打卡时间
        lx: '0',
        //类型，默认填0？？
        fx: -1,
        //方向： 1 上班；2 下班
        openId: this.$utils.Store.getItem('openId'),
        //openId
        userNo: this.$utils.Store.getItem('userNo'),
        //工号
        lname: this.$utils.Store.getItem('userLname'),
        //姓名
        jing: '',
        //经度
        wei: '',
        //纬度
        address: '',
        //定位地址名称
        userImage: '',
        //人脸对比，mmediaId,
        wqImages: '',
        //外勤照片,以逗号分隔，最多四张
        disabled: false,
        arr: []
      }
    };
  },
  watch: {
    isShow: {
      handler: function handler(newShow) {
        var _this2 = this;

        if (newShow) {
          setTimeout(function () {
            _this2.isShow = false;

            _this2.$utils.Store.setItem('outSideTime', null);

            setTimeout(function () {
              _this2.$router.go(-1);
            }, 1000);
          }, 2000);
        }
      },
      deep: true
    },
    show: {
      handler: function handler(newShow) {
        var _this3 = this;

        if (newShow) {
          setTimeout(function () {
            _this3.show = false;
          }, 2000);
        }
      },
      deep: true
    },
    imgArr: {
      handler: function handler(newArr) {
        var _this4 = this;

        if (newArr) {
          this.arr = [];
          this.params.arr = this.imgArr;
          this.imgArr.forEach(function (item) {
            _this4.arr.push(item.mediaId);
          });
          this.params.wqImages = this.arr.join(',');
        }
      },
      deep: true
    }
  },
  methods: {
    closeDialogFail: function closeDialogFail() {
      this.isError = false;
      this.imgArr = [];
      this.currentIndex = -1;
      this.params.fx = -1;
      this.params.outsideInfo = '';
      this.params.userImage = '';
      this.params.wqImages = '';
      this.$utils.Store.set('outSideId', null);
    },
    repeatClick: function repeatClick() {
      var positionInfo = JSON.parse(this.$utils.Store.getItem('resp'));
      this.params.jing = positionInfo.longitude;
      this.params.wei = positionInfo.latitude;
      this.params.address = positionInfo.address;
      this.$utils.Store.set('outSideId', this.params);
      this.$router.push({
        name: '打开拍照',
        query: {
          id: 3
        }
      });
    },
    //当前时段
    currentFx: function currentFx(index) {
      this.currentIndex = index;
      if (index == 2) this.params.fx = 0;else this.params.fx = index + 1;
    },
    goTop: function goTop() {
      var _this5 = this;

      setTimeout(function () {
        _this5.isFresh = true;
        window.scrollTo(0, 0);
      }, 100);
    },
    showFresh: function showFresh() {
      this.isFresh = false;
    },
    //判断是否需要打卡
    getValue: function getValue() {
      var _this6 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return _this6.$api.Attence.getKqSettting().then(function (res) {
                  _this6.wqImage = res.data.wqImage;
                  _this6.wqCheck = res.data.wqCheck;
                });

              case 2:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    goTakePhoto: function goTakePhoto() {
      if (this.params.fx < 0) {
        return this.$utils.Tools.toastShow('请选择时段');
      }

      if (!this.params.outsideInfo) {
        return this.$utils.Tools.toastShow('请选择填写外勤原因');
      }

      this.params.sj = this.$utils.Store.getItem('outSideTime');
      var positionInfo = JSON.parse(this.$utils.Store.getItem('resp'));
      this.params.jing = positionInfo.longitude;
      this.params.wei = positionInfo.latitude;
      this.params.address = positionInfo.address;

      if (this.wqCheck) {
        this.$utils.Store.set('outSideId', this.params);
        this.$router.push({
          name: '打开拍照',
          query: {
            id: 3
          }
        });
        /* id等于三外勤打卡 */
      } else {
        this.tijiao();
      }
    },
    chooseImage: function chooseImage(Serial) {
      var _this7 = this;

      this.$utils.Tools.getEnv(function (res) {
        if (res === 0 || res === 1) {
          _this7.wxChooseImage(Serial);
        }
      });
    },
    wxChooseImage: function wxChooseImage() {
      var _this8 = this;

      setTimeout(function () {
        _this8.$utils.WeiXin.wxChooseImage(function (res) {
          if (res.length > 0) {
            _this8.uploadImage(res);
          }
        }, 4 - _this8.imgArr.length);
      }, 1000);
    },
    showId: function showId(arr, i) {
      var _this = this;

      return new Promise(function (resolve) {
        window.vm.$wechat.uploadImage({
          localId: arr[i],
          // 需要上传的图片的本地ID，由chooseImage接口获得
          isShowProgressTips: 0,
          // 默认为1，显示进度提示
          success: function success(res) {
            var serverId = res.serverId;

            _this.showUrl(serverId);

            i++;

            if (i < arr.length) {
              _this.showId(arr, i);
            }

            resolve();
          }
        });
      });
    },
    showUrl: function showUrl(serverId) {
      var _this9 = this;

      this.$api.Sys.getWxImageUrl(serverId, this.$params.mode).then(function (res) {
        var obj = {
          mediaId: serverId,
          url: res.data
        };

        _this9.imgArr.push(obj);
      });
    },
    uploadImage: function uploadImage(res) {
      var _this10 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return _this10.showId(res, 0);

              case 2:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    tijiao: function tijiao() {
      if (this.params.fx < 0) {
        return this.$utils.Tools.toastShow('请选择时段');
      }

      if (!this.params.outsideInfo) {
        return this.$utils.Tools.toastShow('请选择填写外勤原因');
      }

      this.disabled = true;
      this.addRecord(this.params);
    },
    addRecord: function addRecord(params) {
      var _this11 = this;

      this.$api.Out.addWq(params).then(function (res) {
        _this11.show = false;
        _this11.disabled = false;
        _this11.arr = [];

        _this11.$utils.Store.set('outSideId', '');

        if (+res.code == 600) {
          _this11.isShow = true;
          _this11.currentTime = params.sj;
          _this11.msg = '考勤打卡成功';
          _this11.params.outsideInfo = '';
          _this11.params.fx = -1;
          _this11.currentIndex = -1;

          _this11.getSysDate();
        } else {
          _this11.isError = true;
          _this11.errorMsg = res.msg;
          _this11.params.fx = params.fx;
        }
      });
    },
    //上传外勤照片
    takePhoto: function takePhoto() {
      this.chooseImage(1);
    },
    //删除
    delItem: function delItem(index) {
      this.imgArr.splice(index, 1);
      this.params.wqImages = '';
      var arr = [];
      this.imgArr.forEach(function (item) {
        arr.push(item.mediaId);
      });
      this.params.wqImages = arr.join(',');
    },
    //外勤打卡获取服务器时间
    getSysDate: function getSysDate() {
      var _this12 = this;

      this.$api.Sys.getSystemDate(this.$params.mode).then(function (response) {
        var code = response.code,
            msg = response.msg,
            data = response.data; // this.params.sj = response.data.sysDate

        var time = _this12.$utils.Store.getItem('outSideTime');

        if (time) {
          _this12.params.sj = response.data.sysDate;

          _this12.$utils.Store.setItem('outSideTime', _this12.params.sj);
        } else {
          _this12.params.sj = time;
        }

        if (!_this12.params.sj) {
          _this12.params.sj = response.data.sysDate;

          _this12.$utils.Store.setItem('outSideTime', _this12.params.sj);
        }

        _this12.time = response.data.sysDate.split(' ')[1];

        _this12.showCurrentImg();

        if (+code !== _this12.$code.success) {
          _this12.$utils.Tools.toastShow(msg);
        } else {
          _this12.currDate = data.sysDate;
        }
      }).catch(function () {
        _this12.$utils.Tools.httpError();
      });
    },
    showCurrentImg: function showCurrentImg() {
      var params = this.$utils.Store.get('outSideId'); //获取拍照

      if (params && params.userImage) {
        this.show = true;
        this.params.outsideInfo = params.outsideInfo;
        this.params.wqImages = params.wqImages;
        this.imgArr = params.arr;
        if (params.fx == 0) this.currentIndex = 2;else this.currentIndex = params.fx - 1;
        this.addRecord(params);
      } else if (params && params.waiqindakaishib) {
        this.isError = params.waiqindakaishib && params.waiqindakaishib ? params.waiqindakaishib : true;
        this.errorMsg = params.errMsg && params.errMsg ? params.errMsg : '人脸校验失败';
        params.waiqindakaishib = false;
      }
    }
  },
  computed: {},
  created: function created() {},
  mounted: function mounted() {
    this.$utils.Store.removeItem('address');
    this.$utils.Store.removeItem('resp');
    this.userSerial = this.$utils.Store.getItem('userSerial');
    this.getValue();
    this.getSysDate();
  }
};